import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { DataService } from '../../shared/services/data.service';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceGuard implements CanActivate, CanActivateChild {

  constructor(
    private router: Router
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.isMaintenance(state);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.isMaintenance(state);
  }

  isMaintenance(state) {
    if (state.url.includes('maintenance')) {
      if (!DataService.isMaintenance) {
        this.router.navigate([DataService.getData().defaultPageUrl]).then();
        return false;
      }
      return true;
    } else {
      if (DataService.isMaintenance) {
        this.router.navigate(['/maintenance']).then();
        return false;
      }
      return true;
    }
  }

}
